import Head from "next/head";
import styles from "@/styles/Home.module.css";
import { ComponentMyProfile } from "@/components/ui/Screens/Account";
import { RouteGuard } from "@/components/RouteGuard";

export default function AccountMyProfile() {
	return (
		<div className={styles.container}>
			<Head>
				<title>My Profile</title>
				<link rel="icon" href="/favicon.ico" />
				<link rel="apple-touch-icon" sizes="180x180" href="/apple-touch-icon.png" />
				<link rel="icon" type="image/png" sizes="32x32" href="/favicon-32x32.png" />
				<link rel="icon" type="image/png" sizes="16x16" href="/favicon-16x16.png" />
				<link rel="manifest" href="/site.webmanifest" />
				<link rel="mask-icon" href="/safari-pinned-tab.svg" color="#ffb11a" />
				<meta name="msapplication-TileColor" content="#da532c" />
				<meta name="theme-color" content="#ffffff" />
				<meta
					property="og:image"
					content="https://royal-air.s3.us-west-2.amazonaws.com/pub/royal-air-charter.jpg"
				></meta>
				<meta
					name="twitter:image"
					content="https://royal-air.s3.us-west-2.amazonaws.com/pub/royal-air-charter.jpg"
				></meta>
				<meta
					name="description"
					content="Michigan's top rated private jet charter services, arrive on time and in style, service to the continental United States, call us for private or business travel services."
				></meta>
			</Head>

			<main style={{ padding: 0, width: "100%", minHeight: "100vh" }}>
				<RouteGuard>
					<ComponentMyProfile />
				</RouteGuard>
			</main>
		</div>
	);
}
